import React from 'react';

import '../stylesheet/geosuggest.css'
import '../stylesheet/navbar.css'
import '../stylesheet/application.css'
import '../stylesheet/regtabs.css'
import '../stylesheet/material.css'
import '../stylesheet/radiobuttonstyle.css'

import Register from './register/register.jsx'
import Description from './description/description.jsx'
import GusetNavbar from './navigation/guestnavbar.jsx';
import ContactUs from './contactus/contactus.jsx'

class Application extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0
        }
    }
    componentDidMount() {
        localStorage.setItem("loginState", false)
    }

    render() {

        return (
            <div style={{ marginTop: 60 }}>
                <GusetNavbar />
                <div className="container" >
                    <Register />
                    <Description />
                    <div className="box-shadow-style" style={{ marginTop: 20 }}>
                        <ContactUs />
                    </div>

                </div>

            </div>
        );
    }
}



export default Application;



// WEBPACK FOOTER //
// ./src/components/application.jsx